import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_header = _resolveComponent("page-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_toggle = _resolveComponent("ion-toggle")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_page_header, {
        showBackButton: true,
        hideSchoolLogo: true,
        hideUserProfileToolbar: true
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding ion-text-center",
            fixed: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      ($setup.loading)
                        ? (_openBlock(), _createBlock(_component_ion_col, {
                            key: 0,
                            size: "12",
                            class: "ion-text-center ion-margin-top"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_spinner)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!$setup.loading && $setup.user.id)
                        ? (_openBlock(), _createBlock(_component_ion_col, {
                            key: 1,
                            "size-xs": "12",
                            "size-md": "4"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("img", {
                                class: "user-image",
                                src: $setup.getAppSheetFileLink('user', $setup.user.profilePic)
                              }, null, 8, _hoisted_1),
                              _createVNode(_component_ion_button, {
                                class: "ion-margin-top",
                                color: "light",
                                size: "small",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.updateProfilePic()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "start",
                                    icon: $setup.camera
                                  }, null, 8, ["icon"]),
                                  _createTextVNode(" " + _toDisplayString($setup.t('UserProfilePage.changeProfilePhoto')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_ion_col, null, {
                        default: _withCtx(() => [
                          (!$setup.loading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                ($setup.user.id)
                                  ? (_openBlock(), _createBlock(_component_ion_card_header, { key: 0 }, {
                                      default: _withCtx(() => [
                                        ($setup.user.schoolId)
                                          ? (_openBlock(), _createBlock(_component_ion_card_title, { key: 0 }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("b", null, [
                                                  _withDirectives(_createElementVNode("span", null, _toDisplayString($setup.user.class) + _toDisplayString($setup.formatStudentNumber($setup.user.studentNumber)) + " | ", 513), [
                                                    [_vShow, $setup.user.class]
                                                  ]),
                                                  _createTextVNode(" " + _toDisplayString($setup.user.schoolId.toUpperCase()), 1)
                                                ])
                                              ]),
                                              _: 1
                                            }))
                                          : _createCommentVNode("", true),
                                        _withDirectives(_createVNode(_component_ion_card_title, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.user.fullName) + " ", 1),
                                            ($setup.user.preferredName)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString($setup.user.preferredName) + ")", 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }, 512), [
                                          [_vShow, $setup.user.fullName]
                                        ]),
                                        _createVNode(_component_ion_card_subtitle, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.user.email), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_card_subtitle, null, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString($setup.user.phone), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : ($setup.user.schoolId)
                                    ? (_openBlock(), _createBlock(_component_ion_card_header, { key: 1 }, {
                                        default: _withCtx(() => [
                                          _withDirectives(_createVNode(_component_ion_card_title, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString($setup.user.schoolId.toUpperCase()), 1)
                                            ]),
                                            _: 1
                                          }, 512), [
                                            [_vShow, $setup.user.schoolId]
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                ($setup.user.secondarySchoolStudent?.group == 'ucircle')
                                  ? (_openBlock(), _createBlock(_component_ion_chip, {
                                      key: 2,
                                      outline: "",
                                      color: "primary"
                                    }, {
                                      default: _withCtx(() => [
                                        _cache[15] || (_cache[15] = _createTextVNode(" UCircle ")),
                                        _createVNode(_component_ion_icon, {
                                          color: "warning",
                                          icon: $setup.star
                                        }, null, 8, ["icon"])
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_ion_card_content, null, {
                            default: _withCtx(() => [
                              ($setup.user.id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                    _createVNode(_component_ion_button, {
                                      class: "ion-margin-bottom",
                                      expand: "block",
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openEditUserProfileModal()))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_ion_icon, {
                                          slot: "start",
                                          icon: $setup.createOutline
                                        }, null, 8, ["icon"]),
                                        _createTextVNode(" " + _toDisplayString($setup.t('UserProfilePage.editPersonalInfo')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_list, null, {
                                default: _withCtx(() => [
                                  ($setup.user.id || $setup.user.schoolId)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        ($setup.user.isAdmin)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                              _createVNode(_component_ion_item, { fill: "outline" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_label, null, {
                                                    default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                      _createTextVNode("Role")
                                                    ])),
                                                    _: 1
                                                  }),
                                                  _createVNode(_component_ion_select, {
                                                    label: "Role",
                                                    interface: "popover",
                                                    modelValue: $setup.user.appRole,
                                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.user.appRole) = $event)),
                                                    onIonDismiss: _cache[3] || (_cache[3] = ($event: any) => ($setup.updateUserAppRole()))
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_select_option, { value: "teacher" }, {
                                                        default: _withCtx(() => _cache[17] || (_cache[17] = [
                                                          _createTextVNode("Teacher")
                                                        ])),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_ion_select_option, { value: "secondary-school-student" }, {
                                                        default: _withCtx(() => _cache[18] || (_cache[18] = [
                                                          _createTextVNode("Secondary Student")
                                                        ])),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_ion_select_option, { value: "university-student" }, {
                                                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                                                          _createTextVNode("University Student")
                                                        ])),
                                                        _: 1
                                                      }),
                                                      _createVNode(_component_ion_select_option, { value: "university-client" }, {
                                                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                                                          _createTextVNode("University Staff / Client")
                                                        ])),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }, 8, ["modelValue"])
                                                ]),
                                                _: 1
                                              }),
                                              _withDirectives(_createElementVNode("div", null, [
                                                _createVNode(_component_ion_item, {
                                                  fill: "outline",
                                                  onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.openSchoolSelectModal())),
                                                  button: ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_input, {
                                                      label: "School",
                                                      class: "ion-text-right",
                                                      type: "text",
                                                      modelValue: $setup.user.schoolId,
                                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.user.schoolId) = $event)),
                                                      required: ""
                                                    }, null, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_item, {
                                                  fill: "outline",
                                                  lines: "none"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_toggle, {
                                                      onIonChange: _cache[6] || (_cache[6] = ($event: any) => ($setup.toggleUserIsAB4School($event.detail.checked))),
                                                      checked: $setup.isAB4User
                                                    }, {
                                                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                                                        _createElementVNode("p", null, "AB4 School?", -1)
                                                      ])),
                                                      _: 1
                                                    }, 8, ["checked"])
                                                  ]),
                                                  _: 1
                                                })
                                              ], 512), [
                                                [_vShow, $setup.user.appRole != 'university-student']
                                              ]),
                                              _createElementVNode("div", null, [
                                                _createVNode(_component_ion_item, { fill: "outline" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_label, null, {
                                                      default: _withCtx(() => _cache[22] || (_cache[22] = [
                                                        _createTextVNode("jobEX")
                                                      ])),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select, {
                                                      interface: "popover",
                                                      modelValue: $setup.user.programId,
                                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.user.programId) = $event)),
                                                      onIonChange: _cache[8] || (_cache[8] = ($event: any) => ($setup.updateUserProgram()))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.jobEXes, (jobEX) => {
                                                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                            key: jobEX['jobEX Name'],
                                                            value: jobEX.relatedProgramIds[0]
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(jobEX['jobEX Name']), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["value"]))
                                                        }), 128))
                                                      ]),
                                                      _: 1
                                                    }, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _withDirectives(_createElementVNode("div", null, [
                                                _createVNode(_component_ion_item, { fill: "outline" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_label, null, {
                                                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                                                        _createTextVNode("Client")
                                                      ])),
                                                      _: 1
                                                    }),
                                                    _createVNode(_component_ion_select, {
                                                      interface: "popover",
                                                      modelValue: $setup.user.clientId,
                                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.user.clientId) = $event)),
                                                      onIonChange: _cache[10] || (_cache[10] = ($event: any) => ($setup.updateUserClient()))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.allClients.filter(c => c.type == 'University'), (client) => {
                                                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                            key: client.id,
                                                            value: client.id
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(client.fullName), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1032, ["value"]))
                                                        }), 128))
                                                      ]),
                                                      _: 1
                                                    }, 8, ["modelValue"])
                                                  ]),
                                                  _: 1
                                                })
                                              ], 512), [
                                                [_vShow, $setup.user.isUniversityClient]
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_ion_item, {
                                          lines: "none",
                                          "router-link": "/liked",
                                          button: "",
                                          detail: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, {
                                              slot: "start",
                                              icon: $setup.heart
                                            }, null, 8, ["icon"]),
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => _cache[24] || (_cache[24] = [
                                                _createTextVNode("Saved")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ion_item, {
                                          lines: "none",
                                          "router-link": "/browsed",
                                          button: "",
                                          detail: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_icon, {
                                              slot: "start",
                                              icon: $setup.eyeOutline
                                            }, null, 8, ["icon"]),
                                            _createVNode(_component_ion_label, null, {
                                              default: _withCtx(() => _cache[25] || (_cache[25] = [
                                                _createTextVNode("Recently Browsed")
                                              ])),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_ion_item, { lines: "none" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.globe
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_select, {
                                        label: $setup.t('UserProfilePage.language'),
                                        interface: "popover",
                                        modelValue: $setup.locale,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.locale) = $event)),
                                        onIonDismiss: _cache[12] || (_cache[12] = ($event: any) => ($setup.updateUserLocale()))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_select_option, { value: "zh" }, {
                                            default: _withCtx(() => _cache[26] || (_cache[26] = [
                                              _createTextVNode("中文")
                                            ])),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_select_option, { value: "en" }, {
                                            default: _withCtx(() => _cache[27] || (_cache[27] = [
                                              _createTextVNode("English")
                                            ])),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["label", "modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_item, { lines: "full" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_icon, {
                                        slot: "start",
                                        icon: $setup.moon
                                      }, null, 8, ["icon"]),
                                      _createVNode(_component_ion_toggle, {
                                        onIonChange: _cache[13] || (_cache[13] = ($event: any) => ($setup.toggleDarkTheme($event.detail.checked))),
                                        checked: $setup.user.darkTheme == true
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("p", null, _toDisplayString($setup.t('UserProfilePage.darkTheme')), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["checked"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                size: "small",
                                "router-link": "/terms-and-conditions"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('UserProfilePage.termsAndConditions')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                fill: "clear",
                                size: "small",
                                "router-link": "/feedback"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('UserProfilePage.feedback')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_button, {
                color: "medium",
                size: "small",
                class: "logout-btn",
                onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.doLogout()))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_icon, {
                    slot: "end",
                    icon: $setup.logOutOutline
                  }, null, 8, ["icon"]),
                  _createTextVNode(" " + _toDisplayString($setup.t('UserProfilePage.logout')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "ion-justify-content-center ion-margin-top" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_note, null, {
                    default: _withCtx(() => [
                      _createTextVNode("Ver. " + _toDisplayString($setup.versionCode), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}